export const USER_STATUSES = {
  UNDER_REVIEW: {
    key: 'UNDER_REVIEW',
    className: 'light-info'
  },
  APPROVED: {
    key: 'APPROVED',
    className: 'light-primary'
  },
  REJECTED: {
    key: 'REJECTED',
    className: 'light-dark'
  },
}
export const getStatuses = () => {
  return Object.values(USER_STATUSES)
}
export const getStatusesKeys = (role) => {
  return getStatuses(role).map(v => v.key)
}

export const isApproved = entity => entity.status !== USER_STATUSES.APPROVED.key

